(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-chart"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const triggers = document.querySelectorAll('[data-modal-trigger]');
    const modals = document.querySelectorAll('[data-modal]');

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        // Prevent default if it's an anchor
        if (trigger.tagName.toLowerCase() === 'a') {
          e.preventDefault();
        }

        const modalId = trigger.getAttribute('data-modal-trigger');
        const modal = document.getElementById(modalId);
        if (modal) modal.classList.remove('hidden');
      });
    });

    modals.forEach((modal) => {
      modal.querySelectorAll('[data-modal-close]').forEach((closeBtn) => {
        closeBtn.addEventListener('click', (e) => {
          // Prevent default if it's an anchor
          if (closeBtn.tagName.toLowerCase() === 'a') {
            e.preventDefault();
          }

          modal.classList.add('hidden');
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
